import React from 'react';
import { motion } from 'framer-motion';
import { t } from '../utils/i18n';

const ProductFilter = ({ 
  categories, 
  selectedCategory, 
  onCategoryChange, 
  priceRange, 
  maxPrice,
  onPriceRangeChange, 
  sortOption, 
  onSortOptionChange, 
  language
}) => {
  return (
    <div className="p-6 rounded-[2rem]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h3 className="text-xl font-semibold text-akasha-brown mb-6">{t('filter.title', language)}</h3>
        
        {/* Category Filter */}
        <div className="mb-8">
          <h4 className="text-lg font-medium text-akasha-brown mb-3">{t('filter.categories.title', language)}</h4>
          <div className="space-y-2">
            <div className="flex items-center">
              <input
                type="radio"
                id="all-categories"
                name="category"
                checked={selectedCategory === null}
                onChange={() => onCategoryChange(null)}
                className="h-4 w-4 text-akasha-brown focus:ring-akasha-brown bg-neutral-300 border-neutral-400 focus:ring-offset-0"
              />
              <label htmlFor="all-categories" className="ml-2 text-akasha-black">
                {t('filter.categories.all', language)}
              </label>
            </div>
            
            {categories.map(category => (
              <div key={category._id || category.name} className="flex items-center">
                <input
                  type="radio"
                  id={`category-${category.slug || category.name}`}
                  name="category"
                  checked={selectedCategory === category.name}
                  onChange={() => onCategoryChange(category.name)}
                  className="h-4 w-4 text-akasha-brown focus:ring-akasha-brown bg-neutral-300 border-neutral-400 focus:ring-offset-0"
                />
                <label htmlFor={`category-${category.slug || category.name}`} className="ml-2 text-akasha-black">
                  {category.name}
                </label>
              </div>
            ))}
          </div>
        </div>
        
        {/* Price Range Filter */}
        <div className="mb-8">
          <h4 className="text-lg font-medium text-akasha-brown mb-3">{t('filter.price.title', language)}</h4>
          <div className="px-1">
            <input
              type="range"
              min="0"
              max={maxPrice}
              value={priceRange}
              onChange={(e) => onPriceRangeChange(parseInt(e.target.value))}
              className="w-full h-2 bg-neutral-600/30 rounded-lg appearance-none cursor-pointer accent-akasha-brown"
            />
            <div className="flex justify-between mt-2 text-sm text-gray-700">
              <span>$0</span>
              <span>{t('filter.price.upTo', language)} ${priceRange.toLocaleString()}</span>
            </div>
          </div>
        </div>
        
        {/* Sort Options */}
        <div>
          <h4 className="text-lg font-medium text-akasha-brown mb-3">{t('filter.sortBy.title', language)}</h4>
          <select
            value={sortOption}
            onChange={(e) => onSortOptionChange(e.target.value)}
            className="w-full p-2 border border-neutral-400 rounded-md focus:ring-akasha-brown focus:border-akasha-brown bg-neutral-200 text-akasha-black"
          >
            <option value="featured" className="text-black">{t('filter.sortBy.featured', language)}</option>
            <option value="price-low" className="text-black">{t('filter.sortBy.priceLow', language)}</option>
            <option value="price-high" className="text-black">{t('filter.sortBy.priceHigh', language)}</option>
            <option value="name-asc" className="text-black">{t('filter.sortBy.nameAsc', language)}</option>
            <option value="name-desc" className="text-black">{t('filter.sortBy.nameDesc', language)}</option>
          </select>
        </div>
      </motion.div>
    </div>
  );
};

export default ProductFilter;
